import { Injectable } from "@angular/core";
import { Http, RequestOptions, Response, Headers } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { apiUrl } from "./../../config";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class ServiceprovidertypesService {
  // private headers = new Headers({'Content-Type': 'application/json'});

  // private auth64 = btoa("test");
  // private tokenHeaders = new Headers({
  // 'Content-Type': 'application/x-www-form-urlencoded',
  // 'Authorization': 'Basic '+this.auth64
  // });
  constructor(private http: Http) {}

  getServiceProviderType() {
    var url = apiUrl + "/serviceProviderType";
    //const url = "http://localhost/deutz1/public/serviceProviderType";
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  getservice(id: any): Observable<any> {
    var url = apiUrl + "/getservice/" + id;
    // var url = 'http://localhost/deutz1/public/getservice';
    // const body = 'data=' + id;

    // const headers: Headers = new Headers();
    // headers.append('Access-Control-Allow-Methods', 'POST')
    // headers.append('Content-Type', 'application/x-www-form-urlencoded');
    // headers.append('Access-Control-Allow-Origin', '*');

    // const options = new RequestOptions({
    //   headers: headers
    // });

    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  upload(fileToUpload: any, time_name): Observable<any> {
    let input = new FormData();
    input.append("file", fileToUpload);
    input.append("time_name", time_name);
    return this.http.post(apiUrl + "/uploadimage", input).map(res => {
      console.log(res);
      return res;
    });
    // return this.http.post("http://localhost/deutz1/public/uploadimage", input).map(
    //   res => {
    //     return res;
    //   }
    // );
  }

  updateservice(data: any, img: any): Observable<any> {
    //console.log(img);
    var url = apiUrl + "/updateservice";
    //var url = 'http://localhost/deutz1/public/updateservice';
    const body = "data=" + btoa(JSON.stringify(data)) + "&img=" + img;

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    const options = new RequestOptions({
      headers: headers
    });

    return this.http.post(url, body, options).map(res => {
      console.log(res);
      return res;
    });
  }

  addservice(data: any, img: any): Observable<any> {
    //console.log(img);
    var url = apiUrl + "/addservice";
    //var url = 'http://localhost/deutz1/public/addservice';
    const body = "data=" + btoa(JSON.stringify(data)) + "&img=" + img;

    const headers: Headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    const options = new RequestOptions({
      headers: headers
    });

    return this.http.post(url, body, options).map(res => {
      console.log(res);
      return res;
    });
  }

  deleteservice(id: any) {
    var url = apiUrl + "/deleteservice/" + id;
    // const url = "http://localhost/deutz1/public/deleteservice";
    //  const body = 'data=' + id;

    // const headers: Headers = new Headers();
    // headers.append('Access-Control-Allow-Methods', 'POST');
    // headers.append('Content-Type', 'application/x-www-form-urlencoded');
    // headers.append('Access-Control-Allow-Origin', '*');

    // const options = new RequestOptions({
    //   headers: headers
    // });
    return this.http.get(url).map(res => {
      const data = res.json();
      return data;
    });
  }
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_services/serviceprovidertypes/serviceprovidertypes.service.ts